import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import logo from "../../images/Logo.svg";
import logoutIcon from '../../styles/icons/logout.svg';
import avatar from "../../images/avatar.png";
import { logout } from "../login/SesionService";
import { verificarRol, mostrarModificarContrasenha, username, getNombreSeccion } from "../../constans/constants";
import { actualizaPassword } from "../usuario/UsuarioService";
import { esSesionAdmin } from "../usuario/Usuario";
import DatosUsuarioModal from "../usuario/DatosUsuarioModal";
import { Modal } from "react-bootstrap";
import Cookies from "universal-cookie";
import RoutesAdmin from "../../RoutesAdmin";
import RoutesUsu from "../../Routes";
import { ReactComponent as Menu } from "../../assets/images/icons/menu.svg"
import { ReactComponent as Upload } from "../../assets/images/icons/upload_file.svg"
import Navbar from "./Navbar";


async function tipoNavigation(props) {
  if (props?.sessionData?.admin) {
    return RoutesAdmin;
  } else {
    return RoutesUsu;
  }
}

function Navigator(props) {

  const [routes, setRoutes] = useState([]);
  const [modalDatosUsuario, setModalDatosUsuario] = useState(false);
  const cookies = new Cookies();
  const location = useLocation();

  useEffect(() => {
    async function fetchRoutes() {
      const rutas = await tipoNavigation(props);
      setRoutes(rutas);
    }
    fetchRoutes();
  }, [props.sessionData]);

  const handleLogout = () => {
    logout();
  };

  const nomreUsuario = () => {
    return props.sessionData?.admin
      ? cookies.get("username")
      : props.empresasUser?.nombreCompleto;
  };

  const urlLocation = (raiz) => {
    return location.pathname.includes(raiz) ? "sidebar__item active" : "sidebar__item";
  };

  return (
    <>
      <Modal
        size="lg"
        centered
        show={modalDatosUsuario}
        onHide={() => setModalDatosUsuario(false)}
        keyboard={false}
      >
        <DatosUsuarioModal
          nombreUsuario={username()}
          handleClose={() => setModalDatosUsuario(false)}
          dialogTitle="Datos de usuario"
        />
      </Modal>

      <nav className="sidebar-nav expanded" id="sidebar">
        {/* Sección Rail */}
        <section className="sidebar-nav__rail">
          <button className="sidebar__toggle">
            <Menu className="icon-img dark-icon" />
          </button>

          <div className="sidebar-rail__content">
            {!esSesionAdmin()
              ? routes.map(({ id, url, rol, raiz, icon: IconComponent }) =>
                verificarRol(props.roles, rol) ? (
                  <div key={id} className={urlLocation(raiz)}>
                    <Link to={url} className="sidebar__link">
                      <div className="icon">
                        <IconComponent className="icon-img dark-icon" />
                      </div>
                      <span className="sidebar__link-txt">{id}</span>
                    </Link>
                  </div>
                ) : null
              )
              : null
            }
          </div>
        </section>

        {/* Sección Tray */}
        <section className="sidebar-nav__tray">
          <button className="sidebar__toggle">
            <span className="material-symbols-outlined">close</span>
          </button>

          <img src={logo} className="nav-logo" alt="Logotipo MiRecibo" />
          <Navbar menuActual={window.location.hash} seccionActual={getNombreSeccion(window.location.hash)} />
          <div className="scroll-content">
          </div>
        </section>
      </nav>
    </>
  );
}

const mapStateToProps = (state) => ({
  sessionData: state.sessionData,
  roles: state.rolesData,
  empresasUser: state.empresaUser,
  sideBar: state.sideBar,
});

export default connect(mapStateToProps)(Navigator);
